import { FC } from "react";
import { Form, FormProps, Menu, MenuProps } from "antd";
import PaymentStatus from "../../types/paymentStatus.type";
import {
  INVOICE_STATUS_NAMES,
  REQUEST_STATUS_NAMES,
} from "../../utils/invoiceStatus";

const DEFAULT_SELECTED_KEY = "ALL";

export type FilterPaymentStatus = PaymentStatus | "ALL";

interface IProps extends FormProps {
  defaultValue?: FilterPaymentStatus;
  isRequestStatusName?: boolean;
}

export const StatusFilter: FC<IProps> = ({
  defaultValue = DEFAULT_SELECTED_KEY,
  isRequestStatusName = false,
  ...formProps
}) => {
  const getMenuItem = (key: PaymentStatus) => ({
    label: isRequestStatusName
      ? REQUEST_STATUS_NAMES[key]
      : INVOICE_STATUS_NAMES[key],
    key,
  });

  const FILTER_ITEMS: MenuProps["items"] = [
    {
      label: "All requests",
      key: DEFAULT_SELECTED_KEY,
    },
    getMenuItem(PaymentStatus.PENDING),
    getMenuItem(PaymentStatus.COMPLETED),
    getMenuItem(PaymentStatus.REJECTED),
    getMenuItem(PaymentStatus.FAILED),
  ];

  const changeFilterStatus: MenuProps["onClick"] = (item) => {
    formProps?.form?.setFieldValue("status", item.key);
    formProps?.form?.submit();
  };

  return (
    <>
      <Menu
        onClick={changeFilterStatus}
        defaultSelectedKeys={[defaultValue]}
        mode="horizontal"
        items={FILTER_ITEMS}
      />
      <Form {...formProps} hidden>
        <Form.Item name="status" />
      </Form>
    </>
  );
};
